import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BusinessUnitCreditCardInformationModel } from '../business-unit-credit-card-information.model';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { BillingService } from '../../billing.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { CurrencyType } from '@fi-app/customer-billing/customer-billing-price/currency-type';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';

@Component({
    selector: 'fi-business-unit-credit-card-information-view',
    templateUrl: './business-unit-credit-card-information-view.component.html',
    styleUrls: ['./business-unit-credit-card-information-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-credit-card-information-view' },
    standalone: false,
})
export class BusinessUnitCreditCardInformationViewComponent implements OnInit {
    @Input() creditCardInformation: BusinessUnitCreditCardInformationModel;
    editTabs: EditTabsModel;
    constructor(
        private contentLanguagesService: ContentLanguagesService,
        private billingService: BillingService,
        private appTextService: AppTextService,
        private fiStateService: FiStateService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
    }

    private setPageHeaderData() {
        this.editTabs = new EditTabsModel(
            this.appTextService.get('billing.credit_card_info'),
            this.appTextService.get('back'),
        );
    }

    editBusinessUnitCreditCardInformation() {
        this.fiStateService.go(FiStateNames.Billing.Payment.CreditCardInformation.Edit, {
            BusinessUnitId: this.creditCardInformation.BusinessUnitId,
        });
    }

    getLanguageLabel(languageId: number) {
        const applicationLanguages = this.contentLanguagesService.GetApplicationLanguages();
        for (let i = 0; i < applicationLanguages.length; i++) {
            if (applicationLanguages[i].Id == languageId) return applicationLanguages[i].Name;
        }
    }

    getCurrencyLabel(currencyId: CurrencyType) {
        const billingCurrencies = this.billingService.GetBillingCurrencies();
        for (let i = 0; i < billingCurrencies.length; i++) {
            if (billingCurrencies[i].Id == currencyId) return billingCurrencies[i].Name;
        }
    }
}
